import React from "react";

const CLASSES = {
  success: "bg-[hsl(var(--success))]/10 text-[hsl(var(--success))] border-[hsl(var(--success))]/20",
  warning: "bg-[hsl(var(--warning))]/10 text-[hsl(38_92%_30%)] border-[hsl(var(--warning))]/30",
  critical: "bg-[hsl(var(--critical))]/10 text-[hsl(var(--critical))] border-[hsl(var(--critical))]/20",
  primary: "bg-[hsl(var(--primary))]/10 text-[hsl(var(--primary))] border-[hsl(var(--primary))]/20",
  ai: "bg-[hsl(var(--ai))]/10 text-[hsl(var(--ai))] border-[hsl(var(--ai))]/20",
  muted: "bg-secondary text-muted-foreground border-border",
  solidCritical: "bg-[hsl(var(--critical))] text-[hsl(var(--critical-foreground))] border-transparent",
};

export default function StatusBadge({ tone = "muted", children, solid = false, className = "" }) {
  const cls = solid && tone === "critical" ? CLASSES.solidCritical : CLASSES[tone] || CLASSES.muted;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wider rounded-sm border ${cls} ${className}`}>
      {children}
    </span>
  );
}
